const firebaseConfig = {
    apiKey: "AIzaSyDrryldEuO4ap0wtnLNJQ5WjN_V6L4F7qE",
    authDomain: "doctors-portal-by-mahbub.firebaseapp.com",
    databaseURL: "https://doctors-portal-by-mahbub.firebaseio.com",
    projectId: "doctors-portal-by-mahbub",
    storageBucket: "doctors-portal-by-mahbub.appspot.com",
    messagingSenderId: "765731300522",
    appId: "1:765731300522:web:2e8b0e5ca21fb16b3cdcd3"
  };

  export default firebaseConfig;